import type { Lessons } from 'modules/dashboard/core/type';

import type { LessonsInClass } from './type';

import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { ClassStatus } from './enum';

export const getLessonInClass = (
  unscheduled: Lessons[],
  scheduled: Lessons[],
  totalLearner: number,
): LessonsInClass => {
  const day = startOfDay(new Date());
  const newScheduled = scheduled.map((elSchedule) => {
    return {
      ...elSchedule,
      originStart: elSchedule.start,
      originEnd: elSchedule.end,
    };
  });

  const today = newScheduled.filter((lesson) => lesson?.start && isSameDay(lesson.start, day));

  const future = newScheduled.filter(
    (lesson) => lesson?.start && isAfter(lesson.start, endOfDay(new Date())),
  );

  const past = newScheduled.filter(
    (lesson) => lesson?.start && isBefore(new Date(lesson.start), day),
  );

  return {
    today,
    future,
    unscheduled: unscheduled.map((elUnschedule) => {
      return {
        ...elUnschedule,
        originStart: elUnschedule.start,
        originEnd: elUnschedule.end,
      };
    }),
    past,
    totalLearner,
  };
};

export const getStyleClassCompletion = (classCompletion: string) => {
  const color =
    classCompletion === ClassStatus[0]
      ? COLOR.primary['primary-6']
      : classCompletion === ClassStatus[2]
        ? COLOR.green['green-7']
        : COLOR_CONFIG['neutral-text'];

  const borderColor =
    classCompletion === ClassStatus[0]
      ? COLOR.purpel['purpel-3']
      : classCompletion === ClassStatus[2]
        ? COLOR.green['green-4']
        : COLOR.neutralTrans['neutralTrans-25'];

  const backgroundColor =
    classCompletion === ClassStatus[0]
      ? COLOR.purpel['purpel-1']
      : classCompletion === ClassStatus[2]
        ? COLOR.green['green-1']
        : COLOR.neutral['neutral-4'];

  return {
    color,
    borderColor,
    backgroundColor,
  };
};
